const FAQ_ITEMS = [
  { q: '刃牙漫画在哪里可以免费看？', a: '本站收录了刃牙漫画全部系列，无需注册、无需充值，打开网页就能免费在线观看全部章节。采用下拉式阅读模式，翻页流畅不卡顿。' },
  { q: '需要注册账号或者付费吗？', a: '完全不需要。刃牙漫画免费全集阅读无需任何注册或充值，所有内容永久免费开放，你只管看漫画就好。' },
  { q: '漫画画质清晰吗？有高清版吗？', a: '全部漫画均为高清扫描版本，画质清晰锐利，线条细节完整还原。无论是电脑大屏还是手机小屏，阅读体验都非常出色。' },
  { q: '手机可以看吗？支持哪些设备？', a: '当然支持！本站针对手机端做了专属优化，下拉式阅读在手机上体验尤其顺滑。电脑、平板、手机都可以流畅观看刃牙漫画。' },
  { q: '漫画多久更新一次？能第一时间看到最新话吗？', a: '我们密切跟踪刃牙漫画官方连载进度，最新章节发布后会尽快同步更新。建议收藏本站，随时回来看看有没有最新话上线。' },
  { q: '刃牙漫画一共有哪些系列？都齐全吗？', a: '本站收录了《刃牙》《刃牙II》《范马刃牙》《刃牙道》《相扑道》以及刃牙外传系列，覆盖正传、续作和外传，全部免费阅读。' },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          常见问题
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10">
          关于刃牙漫画在线阅读，你想知道的都在这里
        </p>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/80 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer select-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </div>
                <div className="w-6 h-6 items-center justify-center flex-shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}